/* ============================================================
   NFT Wishlist — localStorage engine (no app, no backend).
   - Saves to localStorage under NFT_WISHLIST_KEY.
   - Hearts are any [data-wishlist-toggle] button; bound by
     delegation so Load-More / New In / any future card just work.
   - Maintains a header count and a scrollable drawer.
   Self-contained. Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'nft_wishlist_v1';
  var root = document.documentElement;

  /* ---------- storage ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(id) {
    id = String(id);
    return read().some(function (it) { return String(it.id) === id; });
  }
  function add(item) {
    var list = read();
    if (!list.some(function (it) { return String(it.id) === String(item.id); })) {
      list.unshift(item); // newest first
      write(list);
    }
  }
  function remove(id) {
    id = String(id);
    write(read().filter(function (it) { return String(it.id) !== id; }));
  }

  /* ---------- item payload from a heart button ---------- */
  function itemFromButton(btn) {
    return {
      id: btn.getAttribute('data-wishlist-id'),
      handle: btn.getAttribute('data-wishlist-handle') || '',
      url: btn.getAttribute('data-wishlist-url') || '',
      title: btn.getAttribute('data-wishlist-title') || '',
      brand: btn.getAttribute('data-wishlist-brand') || '',
      price: btn.getAttribute('data-wishlist-price') || '',
      image: btn.getAttribute('data-wishlist-image') || ''
    };
  }

  /* ---------- reflect saved state onto every heart on the page ---------- */
  function syncHearts() {
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var id = btns[i].getAttribute('data-wishlist-id');
      var on = has(id);
      btns[i].classList.toggle('is-wished', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      btns[i].setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  /* ---------- header count ---------- */
  function syncCount() {
    var n = read().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n > 0 ? String(n) : '';
      els[i].classList.toggle('is-empty', n === 0);
    }
  }

  /* ---------- drawer ---------- */
  function drawerEls() {
    return {
      wrap: document.getElementById('nft-wishlist-drawer'),
      list: document.getElementById('nft-wishlist-list'),
      empty: document.getElementById('nft-wishlist-empty')
    };
  }

  function renderDrawer() {
    var d = drawerEls();
    if (!d.list) return;
    var items = read();
    d.list.innerHTML = '';

    if (!items.length) {
      if (d.empty) d.empty.hidden = false;
      d.list.hidden = true;
      return;
    }
    if (d.empty) d.empty.hidden = true;
    d.list.hidden = false;

    var frag = document.createDocumentFragment();
    items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'nft-wl-item';
      row.setAttribute('data-wl-id', it.id);

      var img = it.image
        ? '<a class="nft-wl-thumb" href="' + it.url + '">' +
            '<img src="' + it.image + '" alt="' + escapeAttr(it.title) + '" loading="lazy">' +
          '</a>'
        : '<a class="nft-wl-thumb nft-wl-thumb--blank" href="' + it.url + '"></a>';

      var meta =
        '<div class="nft-wl-meta">' +
          '<a class="nft-wl-brand" href="' + it.url + '">' + escapeHtml(it.brand || it.title) + '</a>' +
          (it.brand ? '<a class="nft-wl-name" href="' + it.url + '">' + escapeHtml(it.title) + '</a>' : '') +
          '<div class="nft-wl-price">' + escapeHtml(it.price) + '</div>' +
          '<button type="button" class="nft-wl-remove" data-wl-remove="' + it.id + '">Remove</button>' +
        '</div>';

      row.innerHTML = img + meta;
      frag.appendChild(row);
    });
    d.list.appendChild(frag);
  }

  function openDrawer() {
    var d = drawerEls();
    if (!d.wrap) return;
    renderDrawer();
    d.wrap.classList.add('is-open');
    d.wrap.setAttribute('aria-hidden', 'false');
    root.classList.add('nft-wl-lock');
  }
  function closeDrawer() {
    var d = drawerEls();
    if (!d.wrap) return;
    d.wrap.classList.remove('is-open');
    d.wrap.setAttribute('aria-hidden', 'true');
    root.classList.remove('nft-wl-lock');
  }

  /* ---------- escaping ---------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, '&quot;');
  }

  /* ---------- capture-phase interception ----------
     The theme makes the whole product card clickable via its own click
     handler. We register in the CAPTURE phase so our handler runs first,
     and use stopImmediatePropagation() to kill the theme's navigation
     before it fires. Covers the heart toggle + drawer open/close. --- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // heart toggle (card or PDP)
    var toggle = t.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var id = toggle.getAttribute('data-wishlist-id');
      if (has(id)) { remove(id); } else { add(itemFromButton(toggle)); }
      syncHearts();
      syncCount();
      if (drawerEls().wrap && drawerEls().wrap.classList.contains('is-open')) renderDrawer();
      return;
    }
    // open drawer (header heart)
    var opener = t.closest('[data-wishlist-open]');
    if (opener) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      openDrawer(); return;
    }
    // close drawer (X or backdrop)
    var closer = t.closest('[data-wishlist-close]');
    if (closer) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      closeDrawer(); return;
    }
  }, true); // <-- capture phase

  /* Some themes trigger card navigation on pointerdown/mousedown, which fire
     before click. Guard those on the heart too, in capture phase. */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-wishlist-toggle], [data-wishlist-open], [data-wishlist-close]')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, true);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('[data-wl-remove]') : null;
    if (rm) {
      e.preventDefault();
      remove(rm.getAttribute('data-wl-remove'));
      syncHearts(); syncCount(); renderDrawer();
      return;
    }
  });

  // Esc closes the drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Cross-tab sync
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { syncHearts(); syncCount(); renderDrawer(); }
  });

  /* ---------- header heart injection (no header.liquid edit) ----------
     Insert a wishlist launcher immediately before the cart icon, in both
     the desktop and mobile right segments. Idempotent. --- */
  function heartSvg() {
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z"/></svg>';
  }
  function makeHeader() {
    var a = document.createElement('button');
    a.type = 'button';
    a.className = 'header__icon-touch nft-wishlist-link';
    a.setAttribute('data-wishlist-open', '');
    a.setAttribute('data-wishlist-injected', '');
    a.setAttribute('aria-label', 'Open wishlist');
    a.innerHTML = heartSvg() + '<span class="nft-wishlist-count" data-wishlist-count></span>';
    return a;
  }
  function injectHeaderHearts() {
    // Cart icon = the header touch-link carrying data-js-cart-icon.
    var carts = document.querySelectorAll('[data-js-cart-icon]');
    for (var i = 0; i < carts.length; i++) {
      var cart = carts[i];
      var seg = cart.parentNode;
      if (!seg) continue;
      // already injected in this segment?
      if (seg.querySelector('[data-wishlist-injected]')) continue;
      seg.insertBefore(makeHeader(), cart);
    }
    syncCount();
  }

  /* ---------- init (and re-sync when new cards are appended) ---------- */
  function init() { injectHeaderHearts(); syncHearts(); syncCount(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Re-sync hearts on infinite-scroll / Load More
  var grid = document.querySelector('.collection__products');
  if (grid && window.MutationObserver) {
    new MutationObserver(function () { syncHearts(); }).observe(grid, { childList: true, subtree: true });
  }

  // expose a tiny API (optional external use)
  window.NFTWishlist = { open: openDrawer, close: closeDrawer, count: function () { return read().length; } };
})();
